var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.147,
    height: 21.124,
    viewBox: "0 0 27.147 21.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4622",
    "data-name": "Path 4622",
    d: "M-6.626-14.236a6.519,6.519,0,0,1,9.146,0,6.554,6.554,0,0,1,.732,8.409L3.2-5.754a1.438,1.438,0,0,1-2,.332,1.435,1.435,0,0,1-.337-2L.912-7.5a3.622,3.622,0,0,0-.386-4.667,3.628,3.628,0,0,0-5.121,0L-9.636-7.12A3.619,3.619,0,0,0-9.636-2a3.616,3.616,0,0,0,4.663.386L-4.9-1.7a1.479,1.479,0,0,1,2,.373A1.439,1.439,0,0,1-3.23.678L-3.3.728A6.5,6.5,0,0,1-11.67.036a6.5,6.5,0,0,1,0-9.187ZM6.626-3.055a6.494,6.494,0,0,1-9.187,0,6.494,6.494,0,0,1-.692-8.369L-3.2-11.5a1.425,1.425,0,0,1,2-.332,1.422,1.422,0,0,1,.337,2l-.049.072A3.626,3.626,0,0,0-.526-5.085a3.628,3.628,0,0,0,5.121,0l5.04-5.045a3.619,3.619,0,0,0,0-5.121,3.617,3.617,0,0,0-4.663-.386l-.072.049a1.469,1.469,0,0,1-2-.333,1.435,1.435,0,0,1,.332-2.005l.072-.05a6.5,6.5,0,0,1,8.369.693,6.491,6.491,0,0,1,0,9.185Z",
    transform: "translate(13.573 19.187)",
    fill: "#a2a2a2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9ed10e1995667dc5a903a3091945fe15.svg";
export { ForwardRef as ReactComponent };